import { render, staticRenderFns } from "./PaymentsDialog.vue?vue&type=template&id=1ba0050c&"
import script from "./PaymentsDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports